import type { LiveComposerEvent } from '../../CreateMusicXml';

/** Stop adaptive reinterpretation without discarding the captured timing evidence. */
export const freezeAdaptiveEventTiming = (event: LiveComposerEvent): LiveComposerEvent => ({
  ...event,
  adaptiveTiming: false,
});

export function transposeEvent(
  event: LiveComposerEvent,
  semitones: number,
  targetMidi?: number,
): LiveComposerEvent {
  const moved = (midi: number) =>
    targetMidi === undefined || targetMidi === midi
      ? Math.max(0, Math.min(127, midi + semitones))
      : midi;
  return {
    ...freezeAdaptiveEventTiming(event),
    midiNotes: [...new Set(event.midiNotes.map(moved))].sort((a, b) => a - b),
    accidentalSpellings: event.accidentalSpellings
      ? Object.fromEntries(
          Object.entries(event.accidentalSpellings).map(([midi, spelling]) => [
            moved(Number(midi)),
            spelling,
          ]),
        )
      : undefined,
    velocities: event.velocities
      ? Object.fromEntries(
          Object.entries(event.velocities).map(([midi, velocity]) => [
            moved(Number(midi)),
            velocity,
          ]),
        )
      : undefined,
  };
}
